import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  lockOpenOutline,
  notificationsOutline,
  refreshOutline,
  starOutline,
} from 'ionicons/icons';

import { ComponentAccess } from '../../../../../common/decorators/component-access.decorator';
import { PurchaseTimelineRow } from '../../models/payment.models';

/**
 * "How your free trial works" — what happens, and when.
 *
 * Purely presentational: every row is built by the host from the SERVER's
 * disclosure, because each date it shows is a promise. The trial length and the
 * first-charge date come from the provider, and the reminder row only exists
 * when the scheduler will genuinely send that email — a hard-coded "we'll remind
 * you on day 5" would be a promise the backend never made.
 */
@Component({
  selector: 'app-purchase-timeline',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonIcon],
  templateUrl: './purchase-timeline.component.html',
  styleUrls: ['./purchase-timeline.component.scss'],
})
@ComponentAccess('PurchaseTimelineComponent')
export class PurchaseTimelineComponent {
  /** Optional: the paywall renders the rows directly under its plan list, where
   *  a second heading would only repeat what the screen already says. */
  readonly heading = input<string>('');
  readonly subheading = input<string>('');
  readonly rows = input.required<readonly PurchaseTimelineRow[]>();

  constructor() {
    addIcons({
      lockOpenOutline,
      notificationsOutline,
      starOutline,
      refreshOutline,
    });
  }
}
